import React from "react"
import ReactDOM from "react-dom/client"
import "./index.css"
import App from "./App"
import reportWebVitals from "./reportWebVitals"
import { HelmetProvider } from 'react-helmet-async'; // SEO ENHANCEMENT

// Ant Design Global Styles - IMPORTANT: This must be imported ONCE in the entire project
import "antd/dist/reset.css";



const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // SEO ENHANCEMENT: HelmetProvider allows dynamic head management for all components.
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()